export const SCHEDULE_TEMPLATE_STEPS = [
    {
        label: "Service period",
        description: "Recurrence and start date.",
    },
    {
        label: "Work",
        description: "Work start and end relative to the service period.",
    },
    {
        label: "Applications",
        description: "Lead time and schedule end.",
    },
    {
        label: "Team",
        description: "Default assignees.",
    },
] as const;
